import { render } from "./operationRecord.vue?vue&type=template&id=2115c7da&scoped=true"
import script from "./operationRecord.vue?vue&type=script&lang=js"
export * from "./operationRecord.vue?vue&type=script&lang=js"

import "./operationRecord.vue?vue&type=style&index=0&id=2115c7da&scoped=true&lang=css"
import "./operationRecord.vue?vue&type=style&index=1&id=2115c7da&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-2115c7da"

export default script